import PropTypes from "prop-types";
import React from "react";
import Rail from "web/react/components/rail/rail";
import DesignerImage from "./designer-image";
import styles from "./designers-rail.css";

function DesignersRail({ title, designers }) {
    return (
        <div className={styles.railWrapper}>
            <Rail title={title} analyticsLabel="designers" className={styles.rail}>
                {designers.map((designer) => {
                    return (
                        <div key={designer.designer_url}>
                            <DesignerImage designer={designer} />
                        </div>
                    );
                })}
            </Rail>
        </div>
    );
}

DesignersRail.propTypes = {
    title: PropTypes.string,
    designers: PropTypes.array.isRequired,
};

export default DesignersRail;
